
export default {
  head() {
    return {
      meta: [...this.$generateMetaTags()],
    };
  },
};
